(() => {
  /* KEYSTONE PDP PRICE SYNC 2026-09-04: sticky/summary/ATC += KeyOptions additionalPriceCents */
  /* KEYSTONE CREATION SUMMARY 2026-09-04: Your SALUS Creation rows from KeyOptions.getCurrentOptions().selections */
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      }).format(cents / 100);
    } catch (err) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const updateCartCount = (count) => {
    qsa('[data-cart-count]').forEach((el) => {
      el.textContent = String(count);
      el.classList.toggle('is-empty', count === 0);
    });
  };

  /* Mobile nav */
  const header = qs('[data-header]');
  const mobileNav = qs('#MobileNav');
  const overlay = qs('.nav-overlay');
  const menuToggle = qs('.js-menu-toggle');

  const setMenu = (open) => {
    if (!header || !mobileNav) return;
    header.classList.toggle('is-menu-open', open);
    document.documentElement.classList.toggle('is-menu-open', open);
    document.body.classList.toggle('is-menu-open', open);
    mobileNav.hidden = !open;
    if (overlay) {
      overlay.hidden = !open;
      if (open) overlay.removeAttribute('hidden');
      else overlay.setAttribute('hidden', '');
    }
    qsa('.js-menu-toggle').forEach((btn) => {
      if (btn.tagName === 'BUTTON' || btn.hasAttribute('aria-expanded')) {
        btn.setAttribute('aria-expanded', String(open));
      }
    });
    document.body.style.overflow = open ? 'hidden' : '';
  };

  qsa('.js-menu-toggle').forEach((btn) => {
    btn.addEventListener('click', () => setMenu(mobileNav && mobileNav.hidden));
  });

  /* Search — icon click reveals a large field; submits to Shopify routes.search_url */
  const search = qs('#HeaderSearch');
  const openSearch = () => {
    if (!search) return;
    search.hidden = false;
    search.removeAttribute('hidden');
    search.classList.add('is-open');
    qs('.js-search-toggle')?.setAttribute('aria-expanded', 'true');
    const input = qs('#HeaderSearchInput');
    if (input) {
      input.focus();
      if (typeof input.select === 'function') input.select();
    }
  };
  const closeSearch = () => {
    if (!search) return;
    search.hidden = true;
    search.setAttribute('hidden', '');
    search.classList.remove('is-open');
    qs('.js-search-toggle')?.setAttribute('aria-expanded', 'false');
  };
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.js-search-toggle');
    if (toggle) {
      event.preventDefault();
      if (!search) return;
      if (search.hidden || search.hasAttribute('hidden') || !search.classList.contains('is-open')) openSearch();
      else closeSearch();
      return;
    }
    if (event.target.closest('.js-search-close')) {
      event.preventDefault();
      closeSearch();
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (search && !search.hidden) {
      closeSearch();
      return;
    }
    if (header && header.classList.contains('is-menu-open')) {
      setMenu(false);
      const menuBtn = qs('.site-header__icon--menu.js-menu-toggle') || menuToggle;
      if (menuBtn && typeof menuBtn.focus === 'function') menuBtn.focus();
    }
  });

  /* Quantity steppers */
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-qty-change]');
    if (!btn) return;
    const wrap = btn.closest('[data-qty]');
    const input = wrap?.querySelector('.qty__input');
    if (!input) return;
    const next = Math.max(1, Number(input.value || 1) + Number(btn.dataset.qtyChange));
    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('#product-form .qty__input');
    if (!input || input.hasAttribute('data-line-key')) return;
    refreshPdpPrices(input);
  });
  document.addEventListener('input', (event) => {
    const input = event.target.closest('#product-form .qty__input');
    if (!input || input.hasAttribute('data-line-key')) return;
    refreshPdpPrices(input);
  });

  /* Cart line quantity */
  document.addEventListener('change', async (event) => {
    const input = event.target.closest('.qty__input[data-line-key]');
    if (!input) return;
    const key = input.dataset.lineKey;
    const quantity = Number(input.value);
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      const cart = await res.json();
      if (cart.item_count !== undefined) {
        window.location.reload();
      }
    } catch (err) {
      window.location.reload();
    }
  });

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-remove-line]');
    if (!link) return;
    event.preventDefault();
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: link.dataset.removeLine, quantity: 0 }),
      });
    } finally {
      window.location.reload();
    }
  });

  /* Gallery */
  qsa('[data-gallery]').forEach((gallery) => {
    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-thumb]');
      if (!thumb) return;
      const id = thumb.dataset.thumb;
      qsa('.product-gallery__thumb', gallery).forEach((el) => el.classList.toggle('is-active', el === thumb));
      qsa('.product-gallery__slide', gallery).forEach((slide) => {
        slide.classList.toggle('is-active', slide.dataset.mediaId === id);
      });
    });
  });

  /* Selected Shopify variant is authoritative. Never product.price / variants[0] unless that id is selected. */
  const parseJson = (node, fallback) => {
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent || '');
    } catch (err) {
      return fallback;
    }
  };

  const pdpRoot = (from) => (from && from.closest ? from.closest('.pdp') : null) || qs('.pdp');

  const variantsFor = (root) => {
    if (!root) return [];
    const picker = root.querySelector('salus-variant-picker');
    if (picker && Array.isArray(picker.variants) && picker.variants.length) return picker.variants;
    const node =
      root.querySelector('[data-product-variants]') ||
      root.querySelector('[data-variants]') ||
      picker?.querySelector('[data-variants]');
    const parsed = parseJson(node, []);
    return Array.isArray(parsed) ? parsed : [];
  };

  const parseMoneyToCents = (text) => {
    if (text == null || text === '') return null;
    const raw = String(text).replace(/[^0-9.,-]/g, '').trim();
    if (!raw) return null;
    const normalized = raw.replace(/,/g, '');
    const n = Number(normalized);
    if (!Number.isFinite(n)) return null;
    if (normalized.includes('.')) return Math.round(n * 100);
    return Math.round(n * 100);
  };

  /* Shopify selected variant is base. SC live unit is customization when present. Never variants[0] / product.price / size labels. */
  const getSelectedShopifyVariant = (root) => {
    if (!root) return null;
    const variants = variantsFor(root);
    const picker = root.querySelector('salus-variant-picker');
    if (picker) {
      const checked = picker.querySelector('input[type="radio"]:checked[data-shopify-variant-id]');
      const chipId = checked ? Number(checked.getAttribute('data-shopify-variant-id')) : NaN;
      if (Number.isFinite(chipId) && variants.length) {
        const byChip = variants.find((v) => Number(v.id) === chipId);
        if (byChip && byChip.price != null) return byChip;
      }
    }
    if (picker && typeof picker.findVariant === 'function') {
      try {
        const found = picker.findVariant();
        if (found && found.id != null && found.price != null) return found;
      } catch (err) {}
    }
    const idInput = root.querySelector('#product-form [data-variant-id], #product-form input[name="id"]');
    const selectedId = idInput ? Number(idInput.value) : NaN;
    if (Number.isFinite(selectedId) && variants.length) {
      const byId = variants.find((v) => Number(v.id) === selectedId);
      if (byId && byId.price != null) return byId;
    }
    if (picker) {
      const selected = qsa('fieldset', picker).map((set) => {
        const checked = set.querySelector('input:checked');
        return checked ? checked.value : '';
      });
      if (selected.some(Boolean)) {
        const match = variants.find((variant) =>
          selected.every((value, index) => !value || variant[`option${index + 1}`] === value)
        );
        if (match && match.price != null) return match;
      }
    }
    if (idInput && idInput.dataset.variantPrice && Number.isFinite(selectedId)) {
      return {
        id: selectedId,
        price: Number(idInput.dataset.variantPrice),
        title: idInput.dataset.variantTitle || '',
        available: true,
      };
    }
    return null;
  };

  /* Cached Keystone unit add-on (cents) from live key:options:price-updated /
     KeyOptions.getCurrentOptions().prices.additionalCents. Never invent $2 rules. */
  let keystoneAddonUnitCents = null;

  const readKeystoneAddonUnitCents = () => {
    if (keystoneAddonUnitCents != null && Number.isFinite(keystoneAddonUnitCents)) {
      return Math.max(0, keystoneAddonUnitCents);
    }
    try {
      const KO = window.KeyOptions;
      if (!KO || typeof KO.getCurrentOptions !== 'function') return 0;
      const cur = KO.getCurrentOptions();
      const add = cur && cur.prices ? Number(cur.prices.additionalCents) : NaN;
      if (Number.isFinite(add) && add >= 0) {
        keystoneAddonUnitCents = add;
        return add;
      }
    } catch (err) { /* Keystone not mounted */ }
    return 0;
  };

  const /* Add-on unit cents for PDP/ATC display only.
     Prefer Keystone live fee (additionalPriceCents / additionalCents).
     Fallback SC: properties[_scVariantPrices] (+ optional _scVariantQtys),
     then parse .bold_option_total — so SCPO re-enable on another theme still works.
     Absent add-on UI → 0. Does not recreate scent/$2 rules. */
  readScAddonUnitCents = (root) => {
    const ks = readKeystoneAddonUnitCents();
    if (ks > 0 || (keystoneAddonUnitCents != null && Number.isFinite(keystoneAddonUnitCents))) {
      return Math.max(0, ks);
    }
    if (!root) return 0;
    const form = root.querySelector('#product-form') || root;
    const pricesEl = form.querySelector('input[name="properties[_scVariantPrices]"]');
    if (pricesEl && pricesEl.value) {
      const prices = pricesEl.value.split(',').map((p) => Number(String(p).trim())).filter((n) => Number.isFinite(n));
      const qtysEl = form.querySelector('input[name="properties[_scVariantQtys]"]');
      let qtys = [];
      if (qtysEl && qtysEl.value) {
        qtys = qtysEl.value.split(',').map((q) => {
          const n = parseInt(String(q).replace('*', ''), 10);
          return Number.isFinite(n) && n > 0 ? n : 1;
        });
      }
      let sum = 0;
      prices.forEach((p, i) => {
        const q = qtys[i] != null ? qtys[i] : 1;
        sum += p * q;
      });
      return sum > 0 ? sum : 0;
    }
    const tot = form.querySelector('.bold_option_total') || root.querySelector('.bold_option_total');
    if (!tot) return 0;
    const cents = parseMoneyToCents(tot.textContent);
    return cents != null && cents > 0 ? cents : 0;
  };

  /* GM WEAK #6: sticky ATC may show only when the selected variant is available
     AND the in-column buy box is not intersecting. Notify Me is the only OOS CTA. */
  function pdpSelectedAvailable(root) {
    const r = root || pdpRoot() || qs('.pdp');
    if (!r) return false;
    const buy = r.querySelector('.pdp__buy');
    if (buy && (buy.hidden || buy.hasAttribute('hidden'))) return false;
    const variant = getSelectedShopifyVariant(r);
    if (!variant) return false;
    return variant.available !== false;
  }

  function syncStickyAtcVisibility(root) {
    const sticky = (root && root.querySelector && root.querySelector('[data-sticky-atc]')) || qs('[data-sticky-atc]');
    if (!sticky) return;
    const r = root || pdpRoot(sticky) || qs('.pdp');
    if (!pdpSelectedAvailable(r)) {
      sticky.hidden = true;
      sticky.setAttribute('hidden', '');
      return;
    }
    const sentinel =
      (r && r.querySelector('[data-sticky-sentinel]')) ||
      qs('[data-sticky-sentinel]') ||
      (r && r.querySelector('.pdp__buy')) ||
      qs('.pdp__buy');
    let intersecting = true;
    if (sentinel) {
      const rect = sentinel.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight || 0;
      const height = Math.max(rect.height, 0);
      const visible = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
      intersecting = height === 0 ? false : visible >= height * 0.15;
    }
    sticky.hidden = intersecting;
    if (intersecting) sticky.setAttribute('hidden', '');
    else sticky.removeAttribute('hidden');
  }

  const applyShopifyVariantDisplays = (root, variant) => {
    if (!root || !variant || variant.price == null) return;
    if (root.dataset.salusApplying === '1') return;
    const shopifyUnit = Number(variant.price);
    if (!Number.isFinite(shopifyUnit)) return;
    root.dataset.salusApplying = '1';
    try {
      const qtyInput = root.querySelector('#product-form .qty__input:not([data-line-key])');
      const qty = Math.max(1, Number(qtyInput?.value || 1) || 1);
      /* Display only: Shopify variant unit + Keystone (or SC fallback) add-on unit;
         ATC = customized unit × qty. Keystone authority = additionalPriceCents. */
      const scAddonUnit = readScAddonUnitCents(root);
      const unit = shopifyUnit + scAddonUnit;
      const unitMoney = money(unit);
      const lineMoney = money(unit * qty);

      const idInput = root.querySelector('#product-form [data-variant-id], #product-form input[name="id"]');
      if (idInput && variant.id != null) {
        idInput.value = String(variant.id);
        idInput.dataset.variantPrice = String(shopifyUnit);
        if (variant.title) idInput.dataset.variantTitle = String(variant.title);
      }
      root.dataset.unitPrice = String(unit);
      root.dataset.shopifyUnit = String(shopifyUnit);
      root.dataset.scAddonUnit = String(scAddonUnit);
      root.dataset.keystoneAddonUnit = String(keystoneAddonUnitCents == null ? '' : keystoneAddonUnitCents);
      root.dataset.linePrice = String(unit * qty);

      const priceAmount = root.querySelector('[data-product-price] .price__amount');
      if (priceAmount) priceAmount.textContent = unitMoney;

      const summaryPrice = root.querySelector('[data-summary-price]');
      if (summaryPrice) summaryPrice.textContent = unitMoney;

      const summarySize = root.querySelector('[data-summary-size]');
      if (summarySize) {
        summarySize.textContent =
          variant.title && variant.title !== 'Default Title' ? variant.title : '—';
      }

      const totalAmount = root.querySelector('[data-product-total-amount]');
      if (totalAmount) totalAmount.textContent = lineMoney;

      const available = variant.available !== false;
      const addButtons = qsa('[data-add-to-cart]', root);
      addButtons.forEach((btn) => {
        btn.disabled = !available;
      });
      const addLabels = qsa('[data-add-label]', root);
      addLabels.forEach((addLabel) => {
        addLabel.innerHTML = available
          ? `Add to cart · <span data-add-price>${lineMoney}</span>`
          : 'Sold out';
      });
      qsa('[data-add-price]', root).forEach((el) => {
        if (!el.closest('[data-add-label]')) el.textContent = lineMoney;
      });

      const buy = root.querySelector('.pdp__buy');
      const notify = root.querySelector('[data-notify-me]');
      const stoqMount = root.querySelector('[data-stoq-notify-mount]');
      // 2026-09-07 STOQ: keep Sold out button visible so Notify Me can attach; do not hide .pdp__buy.
      if (buy) {
        buy.hidden = false;
        buy.removeAttribute('hidden');
      }
      if (notify) {
        // Legacy NotifyMeForm remains theme-hidden via Liquid {% if false %}; keep JS no-op safe.
        notify.hidden = available;
        if (available) notify.setAttribute('hidden', '');
        else notify.removeAttribute('hidden');
        const vField = notify.querySelector('[data-notify-variant]');
        if (vField && variant.id != null) vField.value = String(variant.id);
        const vTitle = notify.querySelector('[data-notify-variant-title]');
        if (vTitle) vTitle.value = variant.title || '';
      }
      if (stoqMount) {
        stoqMount.hidden = available;
        if (available) stoqMount.setAttribute('hidden', '');
        else stoqMount.removeAttribute('hidden');
      }
      const sticky = root.querySelector('[data-sticky-atc]');
      if (sticky && !available) {
        sticky.hidden = true;
        sticky.setAttribute('hidden', '');
      }
    } finally {
      root.dataset.salusApplying = '0';
    }
    requestAnimationFrame(() => syncStickyAtcVisibility(root));
  };

  const refreshPdpPrices = (from) => {
    const root = pdpRoot(from);
    if (!root) return;
    const variant = getSelectedShopifyVariant(root);
    if (!variant) return;
    applyShopifyVariantDisplays(root, variant);
  };

  /* Variant picker */
  
  /* FINAL 8OZ RULE 2026-09-06 (updated five-product): only listed products may offer 8oz on draft theme.
     Allowlist product IDs: Silky Shampoo 11461437076, Hair Conditioner 8215597842710,
     Foaming Bath 11461435028, Skin Perfecting 11396201364, Organic Aloe & Green Tea Cleanser 11396202260. Sold-out other sizes remain visible. Product data unchanged.
     Does not claim cart API / other channels are blocked. */
  const EIGHT_OZ_ALLOWED_PRODUCT_IDS = new Set(['11461437076', '8215597842710', '11461435028', '11396201364', '11396202260', '11461449940']);
  const isEightOzValue = (value) => String(value || '').replace(/\s+/g, '').toLowerCase() === '8oz';
  const isEightOzVariant = (variant) => {
    if (!variant) return false;
    return isEightOzValue(variant.option1) || isEightOzValue(variant.title);
  };
  const productAllowsEightOz = (el) => {
    const pid = String(el?.dataset?.productId || el?.getAttribute?.('data-product-id') || '');
    return EIGHT_OZ_ALLOWED_PRODUCT_IDS.has(pid);
  };
  const isBlockedEightOzValue = (el, value) => isEightOzValue(value) && !productAllowsEightOz(el);
  const isBlockedEightOzVariant = (el, variant) => isEightOzVariant(variant) && !productAllowsEightOz(el);

  class SalusVariantPicker extends HTMLElement {
    connectedCallback() {
      this.variants = parseJson(this.querySelector('[data-variants]'), []);
      if (!Array.isArray(this.variants)) this.variants = [];
      this.optionNames = parseJson(this.querySelector('[data-options]'), []);
      this.stripBlockedEightOz();
      this.addEventListener('change', () => this.sync());
      this.addEventListener('click', (event) => {
        const chip = event.target.closest('input[type="radio"], .option-chip');
        if (!chip) return;
        const val = (chip.value || chip.dataset?.optionValue || '').toString();
        if (isBlockedEightOzValue(this, val)) {
          event.preventDefault();
          event.stopPropagation();
          this.ensureEligibleSizeSelection();
          return;
        }
        requestAnimationFrame(() => this.sync());
      });
      this.querySelectorAll('[data-option-filter]').forEach((input) => {
        input.addEventListener('input', () => this.filter(input));
      });
      this.ensureEligibleSizeSelection();
      this.sync();
    }

    stripBlockedEightOz() {
      if (productAllowsEightOz(this)) return;
      // Value-based: option names may not contain Size/oz (e.g. "Choose your options").
      this.querySelectorAll('[data-option-value]').forEach((chip) => {
        if (isEightOzValue(chip.dataset.optionValue)) {
          chip.remove();
        }
      });
    }

    ensureEligibleSizeSelection() {
      const sets = this.querySelectorAll('fieldset.option-set');
      sets.forEach((set) => {
        const checked = set.querySelector('input[type="radio"]:checked');
        if (checked && isBlockedEightOzValue(this, checked.value)) {
          checked.checked = false;
        }
        let current = set.querySelector('input[type="radio"]:checked');
        if (!current) {
          const radios = Array.from(set.querySelectorAll('input[type="radio"]'));
          // Only auto-pick within sets that had/have size-like values or any remaining radios after strip
          if (!radios.length) return;
          const pick =
            radios.find((r) => {
              const v = (this.variants || []).find((x) => String(x.id) === String(r.getAttribute('data-shopify-variant-id')));
              return v && v.available !== false && !isBlockedEightOzVariant(this, v);
            }) ||
            radios.find((r) => !isBlockedEightOzValue(this, r.value));
          if (pick) pick.checked = true;
        }
      });
      // If URL forces a blocked 8oz variant id, clear it after sync picks a valid one
      try {
        const url = new URL(window.location.href);
        const vid = Number(url.searchParams.get('variant'));
        if (Number.isFinite(vid)) {
          const v = (this.variants || []).find((x) => Number(x.id) === vid);
          if (isBlockedEightOzVariant(this, v)) {
            url.searchParams.delete('variant');
            window.history.replaceState({}, '', url);
          }
        }
      } catch (e) {}
    }

    selectedOptions() {
      return qsa('fieldset', this).map((set) => {
        const checked = set.querySelector('input:checked');
        return checked ? checked.value : '';
      });
    }

    findVariant() {
      const selected = this.selectedOptions();
      const list = Array.isArray(this.variants) ? this.variants : [];
      if (selected.some((value) => isBlockedEightOzValue(this, value))) return null;
      const found = list.find((variant) =>
        selected.every((value, index) => variant[`option${index + 1}`] === value)
      );
      if (isBlockedEightOzVariant(this, found)) return null;
      return found;
    }

    filter(input) {
      const q = input.value.trim().toLowerCase();
      const set = input.closest('fieldset');
      qsa('[data-option-value]', set).forEach((chip) => {
        const match = !q || chip.dataset.optionValue.toLowerCase().includes(q);
        chip.classList.toggle('is-hidden', !match);
      });
    }

    sync() {
      const variant = this.findVariant();
      const root = pdpRoot(this);
      const form = this.closest('form');
      const addButtons = qsa('[data-add-to-cart]', root || document);
      const addLabel = (root || document).querySelector('[data-add-label]');

      if (!variant) {
        addButtons.forEach((btn) => {
          btn.disabled = true;
        });
        if (addLabel) addLabel.textContent = addLabel.dataset.unavailable || 'Unavailable';
        const sticky = (root || document).querySelector('[data-sticky-atc]');
        if (sticky) {
          sticky.hidden = true;
          sticky.setAttribute('hidden', '');
        }
        return;
      }

      applyShopifyVariantDisplays(root || form || document.documentElement, variant);

      this.dispatchEvent(
        new CustomEvent('variant:change', {
          bubbles: true,
          detail: { variant, price: variant.price, id: variant.id },
        })
      );

      const url = new URL(this.dataset.url || window.location.href, window.location.origin);
      url.searchParams.set('variant', variant.id);
      if (variant.id) window.history.replaceState({}, '', url);
    }
  }

  if (!customElements.get('salus-variant-picker')) {
    customElements.define('salus-variant-picker', SalusVariantPicker);
  }

  /* Product recommendations */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;
      fetch(url)
        .then((res) => res.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const incoming = doc.querySelector('product-recommendations');
          if (incoming && incoming.innerHTML.trim()) this.innerHTML = incoming.innerHTML;
        })
        .catch(() => {});
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  /* Ajax add-to-cart with fallback */
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('#product-form');
    if (!form) return;
    if (event.submitter && event.submitter.name === 'checkout') return;
    event.preventDefault();
    const prevErr = form.querySelector('[data-cart-add-error]');
    if (prevErr) { prevErr.hidden = true; prevErr.textContent = ''; }
    const submit = form.querySelector('[name="add"]');
    if (submit) submit.disabled = true;
    try {
      const body = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body,
      });
      let errPayload = null;
      if (!res.ok) {
        try { errPayload = await res.json(); } catch (_) {}
        const msg = (errPayload && (errPayload.description || errPayload.message)) || 'Could not add to cart. Please try again.';
        throw new Error(msg);
      }
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      updateCartCount(cart.item_count);
      window.location.href = '/cart';
    } catch (err) {
      let box = form.querySelector('[data-cart-add-error]');
      if (!box) {
        box = document.createElement('div');
        box.setAttribute('data-cart-add-error', '');
        box.setAttribute('role', 'alert');
        box.style.cssText = 'margin:10px 0 0;padding:10px 12px;border:1px solid #c45;border-radius:8px;background:#fff5f5;color:#8a1f1f;font-size:0.92rem;';
        const anchor = form.querySelector('[data-add-to-cart], [name="add"], .product-form__submit, button[type="submit"]');
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor.nextSibling);
        else form.appendChild(box);
      }
      box.textContent = (err && err.message) ? err.message : 'Could not add to cart. Please try again.';
      box.hidden = false;
    } finally {
      if (submit) submit.disabled = false;
    }
  });


  /* Quick Add — non-customizable cards only. Stay on collection/search; update cart count.
     Customizable cards have no [data-quick-add] (Customize Yours → PDP). Does not touch #product-form. */
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-quick-add]');
    if (!form) return;
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    const prevLabel = submit ? submit.textContent : '';
    if (submit) submit.disabled = true;
    try {
      const body = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body,
      });
      if (!res.ok) throw new Error('add failed');
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      updateCartCount(cart.item_count);
      if (submit) {
        submit.textContent = 'Added';
        setTimeout(() => {
          submit.textContent = prevLabel;
          submit.disabled = false;
        }, 1600);
      }
    } catch (err) {
      if (submit) submit.disabled = false;
    }
  });

  /* Sticky ATC: observe the always-present buy-column sentinel (not the ATC
     button, which is hidden when OOS). Re-check availability on every tick. */
  const stickyAtc = qs('[data-sticky-atc]');
  const stickySentinel = qs('[data-sticky-sentinel]') || qs('.pdp__buy');
  if (stickyAtc && stickySentinel && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(() => {
      syncStickyAtcVisibility();
    }, { threshold: 0.15 });
    io.observe(stickySentinel);
  }
  syncStickyAtcVisibility();

  /* Scent collection live title filter (presentation). Does not touch SC selects. */
  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-scent-search]');
    if (!input) return;
    const q = input.value.trim().toLowerCase();
    const grid = qs('[data-product-grid]') || qs('.product-grid');
    if (!grid) return;
    qsa('.product-card', grid).forEach((card) => {
      const title = card.querySelector('.product-card__title')?.textContent.toLowerCase() || '';
      const handle = card.dataset.productHandle || '';
      const match = !q || title.includes(q) || handle.includes(q);
      card.classList.toggle('is-scent-hidden', !match);
    });
  });

  /* Customizable PDP: restyle SC, filter its options, mirror summary. No second engine. */
  const labelOf = (el) => {
    const wrap = el.closest('.bold_option, .bold_option_element, .sc-product-options, fieldset, .option-set') || el.parentElement;
    return (
      wrap?.querySelector('.bold_option_title, .bold_option_element_title, legend, label, .option-set__legend, .option-title')?.textContent ||
      el.getAttribute('aria-label') ||
      el.name ||
      ''
    ).toLowerCase();
  };

  const displayStrength = (value, opts = {}) => {
    const v = String(value || '').trim();
    if (!v) return '';
    const perScent = !!opts.perScent;
    const token = (v.match(/\b(LIGHT|REGULAR|NORMAL|MEDIUM|HEAVY)\b/i) || [])[1];
    if (token) {
      const up = token.toUpperCase();
      /* Goat legacy: NORMAL → MEDIUM. Per-scent-5 keeps REGULAR as REGULAR. */
      if (!perScent && up === 'NORMAL') return 'MEDIUM';
      return up;
    }
    if (!perScent && /^normal$/i.test(v)) return 'MEDIUM';
    return v.toUpperCase();
  };

  const collectScFields = (form) => {
    const scents = [];
    const scentByIndex = {};
    const strengthByIndex = {};
    let strength = null;
    let addThird = null;
    let surchargeText = '';
    let scenting = null;
    qsa('select, input[type="radio"], input[type="checkbox"], textarea, input[type="text"]', form).forEach((el) => {
      if (el.closest('salus-variant-picker')) return;
      const label = labelOf(el);
      if (/order\s*notes?|note\s*to\s*seller|special\s*instructions|how can we make/.test(label) || el.tagName === 'TEXTAREA') {
        const hideTarget = el.closest('.bold_option') || el.closest('.bold_option_element')?.parentElement || el.parentElement;
        if (hideTarget) hideTarget.classList.add('sc-notes-deemphasized');
        return;
      }
      if (/^scenting$/.test(label.trim()) || (/scenting/.test(label) && !/scent\s*\d/.test(label))) {
        if (el.matches('input[type="radio"]') && el.checked) scenting = el;
        else if (!scenting && el.matches('select')) scenting = el;
        return;
      }
      if (/add\s*3rd|add\s*third|3rd\s*scent/.test(label) && el.matches('input[type="checkbox"], input[type="radio"]')) {
        addThird = el;
        const wrap = el.closest('.bold_option') || el.parentElement;
        const priced = wrap?.querySelector('.bold_option_value_price, .bold_option_total, [data-option-price]');
        if (priced) surchargeText = priced.textContent.trim();
        return;
      }
      const nameL = String(el.name || '').toLowerCase();
      const strengthSlot = label.match(/strength\s*(\d)\s*a?/) || nameL.match(/strength\s*(\d)\s*a?/);
      if (strengthSlot) {
        const idx = parseInt(strengthSlot[1], 10);
        if (el.matches('input[type="radio"], input[type="checkbox"]')) {
          if (el.checked) strengthByIndex[idx] = el;
        } else if (!strengthByIndex[idx]) {
          strengthByIndex[idx] = el;
        }
        return;
      }
      if ((/strength|intensity/.test(label) || /strength/.test(nameL)) && !/scent\s*\d/.test(label)) {
        if (el.matches('input[type="radio"], input[type="checkbox"]')) {
          if (el.checked) strength = el;
        } else if (!strength) {
          strength = el;
        }
        return;
      }
      if (el.tagName === 'SELECT' && (/scent|fragrance|aroma|scenting/.test(label) || /scent/.test(nameL))) {
        if ((/scenting/.test(label) || /scenting/.test(nameL)) && !/scent\s*\d/.test(label) && !/scent\s*\d/.test(nameL)) return;
        const m = label.match(/scent\s*(\d)\s*a?/) || nameL.match(/scent\s*(\d)\s*a?/);
        if (m) scentByIndex[parseInt(m[1], 10)] = el;
        scents.push(el);
      }
    });
    return { scents, scentByIndex, strengthByIndex, strength, addThird, surchargeText, scenting };
  };


  const decoratePerScentPresentation = (root, form) => {
    if (root.dataset.scModel !== "per-scent-5") return;
    const mount = qs("[data-sc-scent-mount]", root);
    if (!mount) return;
    qsa(".bold_option", mount).forEach((block) => {
      const titleEl = block.querySelector(".bold_option_title");
      const rawTitle = (titleEl?.textContent || "").replace(/\*/g, "").trim();
      const named = qsa("select[name], input[name]", block).map((el) => el.name || "").join(" ");
      const blob = `${rawTitle} ${named}`.toLowerCase();
      if (/scenting/.test(blob) && !/scent\s*\d/.test(blob)) {
        block.dataset.salusKind = "scenting";
        block.dataset.salusLabel = "SCENTING";
        return;
      }
      const scentM = rawTitle.match(/scent\s*(\d)\s*a?/i) || named.match(/\[?\s*scent\s*(\d)\s*a?/i);
      if (scentM && block.querySelector("select")) {
        block.dataset.salusKind = "scent";
        block.dataset.salusLabel = "SCENT " + scentM[1];
        return;
      }
      const strM = rawTitle.match(/strength\s*(\d)\s*a?/i) || named.match(/\[?\s*strength\s*(\d)\s*a?/i);
      if (strM) {
        block.dataset.salusKind = "strength";
        block.dataset.salusLabel = "STRENGTH";
        qsa(".bold_option_value", block).forEach((val) => {
          const t = val.querySelector(".bold_option_value_title");
          const text = ((t && t.textContent) || val.textContent || "").trim();
          const token = (text.match(/\b(LIGHT|REGULAR|HEAVY)\b/i) || [])[1];
          if (!token) return;
          const up = token.toUpperCase();
          val.dataset.salusToken = up;
          if (t) t.dataset.salusToken = up;
        });
        return;
      }
      if (/add/.test(blob) && /scent/.test(blob)) {
        block.dataset.salusKind = "add-scent";
        if (/2nd|second/.test(blob)) {
          block.dataset.salusLabel = "ADD A 2ND SCENT";
        } else {
          const n = (rawTitle.match(/(\d)/) || named.match(/(\d)/) || [])[1];
          block.dataset.salusLabel = n ? ("ADD SCENT " + n) : "ADD ANOTHER SCENT";
        }
      }
    });
  };

  const relocateSc = (form, root) => {
    const scentMount = qs('[data-sc-scent-mount]', root);
    const strengthMount = qs('[data-sc-strength-mount]', root);
    if (!scentMount) return;
    const perScent5 = root.dataset.scModel === 'per-scent-5';
    /* Presentation only: move existing SC .bold_option nodes. Do not create/toggle SC logic. */
    const blocks = qsa('.bold_option, .bold_options .bold_option', form);
    if (!blocks.length) {
      qsa('.bold_option, .bold_options .bold_option', root).forEach((b) => blocks.push(b));
    }
    blocks.forEach((block) => {
      const text = (block.textContent || '').toLowerCase();
      if (/order\s*notes?/.test(text)) {
        block.classList.add('sc-notes-deemphasized');
        return;
      }
      if (perScent5) {
        if (!scentMount.contains(block)) scentMount.appendChild(block);
        return;
      }
      if (/strength|intensity/.test(text) && strengthMount && !strengthMount.contains(block)) {
        strengthMount.appendChild(block);
        return;
      }
      if (!scentMount.contains(block) && block.closest('[data-step="strength"]') == null) {
        if (block.querySelector('select') || /scent|fragrance/.test(text)) {
          scentMount.appendChild(block);
        }
      }
    });
  };

  const renderChips = (root, scents) => {
    const host = qs('[data-scent-chips]', root);
    if (!host) return;
    host.innerHTML = '';
    const included = Math.max(0, parseInt(root.dataset.includedScents || '2', 10) || 2);
    scents.forEach((sel, index) => {
      const val = sel.value;
      if (!val || /^--/.test(val) || /choose/i.test(val)) return;
      const chip = document.createElement('span');
      const kind = index < included ? 'Included' : 'Additional charge';
      chip.className = 'pdp__chip ' + (index < included ? 'pdp__chip--included' : 'pdp__chip--paid');
      chip.innerHTML = `<span>Scent ${index + 1} — ${kind}: ${val}</span>`;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Remove scent');
      btn.textContent = '×';
      btn.addEventListener('click', () => {
        sel.selectedIndex = 0;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
      chip.appendChild(btn);
      host.appendChild(chip);
    });
  };

  const writeState = (root, payload) => {
    const node = root.querySelector('#salus-product-state') || document.getElementById('salus-product-state');
    if (!node) return;
    try {
      const data = JSON.parse(node.textContent || '{}');
      data.selected = Object.assign({}, data.selected || {}, payload);
      const maxScents = parseInt(root.dataset.maxScents || '3', 10) || 3;
      const included = parseInt(root.dataset.includedScents || '2', 10) || 2;
      data.maxScents = maxScents;
      data.includedScentCount = included;
      if (root.dataset.scModel === 'per-scent-5') {
        data.strengthOptions = ['LIGHT', 'REGULAR', 'HEAVY'];
        data.scModel = 'per-scent-5';
      } else {
        data.strengthOptions = ['LIGHT', 'MEDIUM', 'HEAVY'];
      }
      node.textContent = JSON.stringify(data);
    } catch (err) {}
  };


  /* Prefer Keystone live selections (same API as price sync). Do not invent scent names. */
  const readKeystoneCurrent = () => {
    try {
      const KO = window.KeyOptions;
      if (!KO || typeof KO.getCurrentOptions !== 'function') return null;
      const cur = KO.getCurrentOptions();
      if (!cur || !cur.loaded) return null;
      if (!(cur.hasOptions || (Array.isArray(cur.selections) && cur.selections.length))) return null;
      return cur;
    } catch (err) {
      return null;
    }
  };

  /* KEYSTONE PUBLIC-LABEL MAP 2026-09-04
     Set 17130 public_names changed (Make It Yours / Your First Scent / How Strong…).
     Prefer optionId (stable); fall back to new + legacy public names. */
  const KS_SCENTING_ID = 29270;

  /* SALUS 2026-09-04: presentation-only Keystone label override (set 17130 unchanged). */
  const START_HERE_LABEL = 'Start Here to Make It Yours';
  const NATURALLY_UNSCENTED_LABEL = 'Naturally Unscented';
  const CUSTOMIZE_MY_SCENT_LABEL = 'Customize My Scent';
  const CUSTOMIZED_LABEL = 'Customized';
  const displayScentingChoice = (raw) => {
    const s = String(raw || '').trim();
    if (/natural\s*\/?\s*no\s*scent/i.test(s) || /^natural(ly)?\s*unscented$/i.test(s)) return NATURALLY_UNSCENTED_LABEL;
    if (/customize/i.test(s)) return CUSTOMIZE_MY_SCENT_LABEL;
    return s;
  };
  /* Creation Summary Scenting row (presentation-only): Natural → Naturally Unscented;
     Customize with no scent yet → Customize My Scent; one or more scents → Customized. */
  const creationScentingSummaryLabel = (scentingVal, isNatural, selectedScentCount) => {
    if (isNatural) return NATURALLY_UNSCENTED_LABEL;
    if (selectedScentCount >= 1) return CUSTOMIZED_LABEL;
    if (/customize/i.test(String(scentingVal || ''))) return CUSTOMIZE_MY_SCENT_LABEL;
    return displayScentingChoice(scentingVal) || CUSTOMIZE_MY_SCENT_LABEL;
  };

  const relabelMakeItYours = () => {
    const root = document.getElementById('key_options_block');
    if (!root) return;
    const walk = (node) => {
      if (!node) return;
      if (node.nodeType === 3) {
        const t = node.nodeValue;
        if (!t) return;
        const trimmed = t.trim();
        if (trimmed === 'Make It Yours' || trimmed === 'Make It Yours:') {
          const lead = t.match(/^\s*/)[0];
          const trail = t.match(/\s*$/)[0];
          node.nodeValue = lead + START_HERE_LABEL + (trimmed.endsWith(':') ? ':' : '') + trail;
        } else if (trimmed === 'Natural / No Scent' || trimmed === 'Natural/No Scent') {
          const lead = t.match(/^\s*/)[0];
          const trail = t.match(/\s*$/)[0];
          node.nodeValue = lead + NATURALLY_UNSCENTED_LABEL + trail;
        }
        return;
      }
      if (node.nodeType !== 1) return;
      if (node.matches && node.matches('script,style,textarea,input,select,option')) return;
      Array.from(node.childNodes || []).forEach(walk);
    };
    walk(root);
    root.querySelectorAll('label, legend, h2, h3, h4, p, span, div').forEach((el) => {
      if (el.childElementCount > 2) return;
      const t = (el.textContent || '').trim();
      if (t === 'Make It Yours' || t === 'Make It Yours:') {
        el.textContent = START_HERE_LABEL + (t.endsWith(':') ? ':' : '');
        el.classList.add('salus-start-here-label');
      } else if (t === 'Natural / No Scent' || t === 'Natural/No Scent') {
        el.textContent = NATURALLY_UNSCENTED_LABEL;
      }
    });
  };


  const KS_SCENT_IDS = { 1: 29271, 2: 29278, 3: 29273, 4: 29274, 5: 29275 };
  const KS_STRENGTH_IDS = { 1: 29272, 2: 29276, 3: 29277, 4: 29279, 5: 29280 };
  const KS_SCENT_NAME_RE = {
    1: /^(your\s+first\s+scent|scent\s*1a?)$/i,
    2: /^(your\s+second\s+scent|scent\s*2a?)$/i,
    3: /^(your\s+third\s+scent|scent\s*3a?)$/i,
    4: /^(your\s+fourth\s+scent|scent\s*4a?)$/i,
    5: /^(your\s+fifth\s+scent|scent\s*5a?)$/i
  };
  const KS_STRENGTH_NAME_RE = {
    1: /^(how strong would you like your scent\??(?:\s*1)?|strength\s*1a?)$/i,
    2: /^(how strong would you like your scent\??\s*2|strength\s*2a?)$/i,
    3: /^(how strong would you like your scent\??\s*3|strength\s*3a?)$/i,
    4: /^(how strong would you like your scent\??\s*4|strength\s*4a?)$/i,
    5: /^(how strong would you like your scent\??\s*5|strength\s*5a?)$/i
  };
  const KS_SCENT_DT = { 1: 'Your First Scent', 2: 'Your Second Scent', 3: 'Your Third Scent', 4: 'Your Fourth Scent', 5: 'Your Fifth Scent' };

  const cleanKeystoneLabel = (name) => {
    const n = String(name || '').trim();
    const m = n.match(/^(Scenting|Scent\s*\d+|Strength\s*\d+|Add(?:\s+a)?\s*(?:\d+(?:nd|rd|th)?\s*)?Scent(?:\s*\d+)?)\s*a$/i);
    return m ? m[1].replace(/\s+/g, ' ').trim() : n;
  };

  const keystoneSelectionMap = (cur) => {
    const map = {};
    const push = (name, value) => {
      if (name == null) return;
      const k = String(name).trim();
      if (!k || k.charAt(0) === '_') return;
      const v = value == null ? '' : String(value).trim();
      map[k] = v;
    };
    (cur.selections || []).forEach((s) => {
      if (s) push(s.name, s.value);
    });
    const vis = cur.properties && cur.properties.visible;
    if (vis && typeof vis === 'object') {
      Object.keys(vis).forEach((k) => {
        if (map[k] == null || map[k] === '') push(k, vis[k]);
      });
    }
    return map;
  };

  const keystoneLookup = (map, re, opts) => {
    const allowCheck = !!(opts && opts.allowCheck);
    for (const k of Object.keys(map)) {
      if (!re.test(k)) continue;
      const v = map[k];
      if (!v) continue;
      if (!allowCheck && (v === '✓' || v === 'on' || v === 'true')) continue;
      if (/^choose|^select|^--|^\s*$/i.test(v)) continue;
      return v;
    }
    return '';
  };

  const usableValue = (v) => {
    const s = v == null ? '' : String(v).trim();
    if (!s) return '';
    if (/^choose|^select|^--|^\s*$/i.test(s)) return '';
    if (s === '✓' || s === 'on' || s === 'true') return '';
    return s;
  };

  const pickKeystoneSel = (cur, optionId, nameRe) => {
    const sels = cur.selections || [];
    const byId = sels.find((s) => s && Number(s.optionId) === Number(optionId));
    if (byId && usableValue(byId.value)) return byId;
    if (nameRe) {
      const byName = sels.find((s) => s && nameRe.test(String(s.name || '')) && usableValue(s.value));
      if (byName) return byName;
    }
    return byId || null;
  };

  const applyKeystoneCreationSummary = (root, cur) => {
    const map = keystoneSelectionMap(cur);
    const scentingSel = pickKeystoneSel(cur, KS_SCENTING_ID, /^(start here to make it yours|make it yours|scenting)$/i);
    const scentingVal = (scentingSel && scentingSel.value) || keystoneLookup(map, /^(start here to make it yours|make it yours|scenting)$/i, { allowCheck: true }) || '';
    const isNatural = /natural|no\s*scent/i.test(scentingVal) && !/customize/i.test(scentingVal);
    const perScent5 = root.dataset.scModel === 'per-scent-5';
    const maxScents = parseInt(root.dataset.maxScents || (perScent5 ? '5' : '3'), 10) || (perScent5 ? 5 : 3);

    let selectedScentCount = 0;
    if (!isNatural) {
      for (let i = 1; i <= maxScents; i++) {
        const scentSel = pickKeystoneSel(cur, KS_SCENT_IDS[i], KS_SCENT_NAME_RE[i]);
        let v = scentSel ? usableValue(scentSel.value) : '';
        if (!v) v = keystoneLookup(map, KS_SCENT_NAME_RE[i]);
        if (v) selectedScentCount += 1;
      }
    }

    const naturalRow = qs('[data-summary-natural-row]', root);
    const naturalDd = qs('[data-summary-natural]', root);
    if (naturalRow) {
      /* Always show Scenting on per-scent-5 (Natural + Customize + Customized). */
      naturalRow.hidden = !perScent5;
      const natDt = naturalRow.querySelector('dt');
      if (natDt) natDt.textContent = 'Scenting';
      if (naturalDd && perScent5) {
        naturalDd.textContent = creationScentingSummaryLabel(scentingVal, isNatural, selectedScentCount);
      }
    }

    for (let i = 1; i <= 5; i++) {
      const row = qs(`[data-summary-scent-${i}-row]`, root);
      const dd = qs(`[data-summary-scent-${i}]`, root);
      if (!row && !dd) continue;
      const scentSel = isNatural ? null : pickKeystoneSel(cur, KS_SCENT_IDS[i], KS_SCENT_NAME_RE[i]);
      let v = scentSel ? usableValue(scentSel.value) : '';
      if (!v && !isNatural) v = keystoneLookup(map, KS_SCENT_NAME_RE[i]);
      const strSel = v ? pickKeystoneSel(cur, KS_STRENGTH_IDS[i], KS_STRENGTH_NAME_RE[i]) : null;
      let stRaw = strSel ? usableValue(strSel.value) : '';
      if (!stRaw && v) stRaw = keystoneLookup(map, KS_STRENGTH_NAME_RE[i], { allowCheck: true });
      const st = stRaw ? displayStrength(stRaw, { perScent: true }) : '';
      const display = v ? (st ? `${v} · ${st}` : v) : '';
      const dt = row && row.querySelector('dt');
      if (dt) dt.textContent = cleanKeystoneLabel((scentSel && scentSel.name) || KS_SCENT_DT[i]);
      if (i === 1) {
        if (row) row.hidden = !!(perScent5 && isNatural);
        if (dd) dd.textContent = (perScent5 && isNatural) ? '' : (display || 'Select a scent');
      } else {
        if (row) row.hidden = !v;
        if (dd && v) dd.textContent = display;
        else if (dd && !v) dd.textContent = '';
      }
    }

    const surRow = qs('[data-summary-surcharge-row]', root);
    const stRow = qs('[data-summary-strength-row]', root);
    if (perScent5) {
      if (surRow) surRow.hidden = true;
      if (stRow) stRow.hidden = true;
    }

    const chipHost = qs('[data-scent-chips]', root);
    if (chipHost) chipHost.innerHTML = '';

    const selectedVariant = getSelectedShopifyVariant(root);
    if (selectedVariant) applyShopifyVariantDisplays(root, selectedVariant);
    const priceEl = qs('[data-summary-price]', root);
    const payload = {
      size: qs('[data-summary-size]', root)?.textContent || null,
      scenting: scentingVal || null,
      natural: isNatural,
      price: selectedVariant && selectedVariant.price != null ? selectedVariant.price : (priceEl ? priceEl.textContent : null),
      source: 'keystone',
    };
    for (let i = 1; i <= maxScents; i++) {
      const scentSel = isNatural ? null : pickKeystoneSel(cur, KS_SCENT_IDS[i], KS_SCENT_NAME_RE[i]);
      const v = isNatural ? null : ((scentSel && usableValue(scentSel.value)) || keystoneLookup(map, KS_SCENT_NAME_RE[i]) || null);
      const strSel = v ? pickKeystoneSel(cur, KS_STRENGTH_IDS[i], KS_STRENGTH_NAME_RE[i]) : null;
      const stRaw = v ? ((strSel && usableValue(strSel.value)) || keystoneLookup(map, KS_STRENGTH_NAME_RE[i], { allowCheck: true })) : '';
      payload['scent' + i] = v;
      payload['strength' + i] = v && stRaw ? displayStrength(stRaw, { perScent: true }) : null;
    }
    writeState(root, payload);
  };

  const syncSalusCreationFromSc = () => {
    const root = qs('[data-customizable="true"]');
    if (!root) return;
    const form = qs('#product-form', root);
    if (!form) return;
    const koCur = readKeystoneCurrent();
    if (koCur) {
      applyKeystoneCreationSummary(root, koCur);
      return;
    }
    relocateSc(form, root);
    const perScent5 = root.dataset.scModel === 'per-scent-5';
    if (perScent5) decoratePerScentPresentation(root, form);
    const maxScents = parseInt(root.dataset.maxScents || (perScent5 ? '5' : '3'), 10) || (perScent5 ? 5 : 3);
    const { scents, scentByIndex, strengthByIndex, strength, addThird, surchargeText, scenting } = collectScFields(form);
    const valOf = (sel) => (sel && sel.value && !/^--|choose/i.test(sel.value) ? sel.value : '');
    /* Read SC scenting state from the live SC control only. */
    const scentingEl = form.querySelector('input[name="properties[Scenting]"]:checked') || scenting;
    const scentingVal = scentingEl
      ? (scentingEl.matches('input[type="radio"], input[type="checkbox"]')
          ? (scentingEl.value || '').trim()
          : valOf(scentingEl))
      : '';
    const isNatural = /natural|no\s*scent/i.test(scentingVal) && !/customize/i.test(scentingVal);

    const ordered = [];
    for (let i = 1; i <= maxScents; i++) {
      if (scentByIndex[i]) ordered.push(scentByIndex[i]);
    }
    const realScents = ordered.length
      ? ordered
      : scents.filter((sel) => {
          const lab = labelOf(sel);
          return /scent\s*[12345]/.test(lab) || !/scenting/.test(lab);
        }).slice(0, maxScents);

    /* Summary only: reflect SC selections. Do not gate SC field visibility. */
    const naturalRow = qs('[data-summary-natural-row]', root);
    const naturalDd = qs('[data-summary-natural]', root);
    if (naturalRow) {
      naturalRow.hidden = !perScent5;
      let selectedScentCount = 0;
      if (!isNatural) {
        for (let i = 1; i <= maxScents; i++) {
          const sel = realScents[i - 1] || scentByIndex[i];
          if (valOf(sel)) selectedScentCount += 1;
        }
      }
      if (naturalDd && perScent5) {
        naturalDd.textContent = creationScentingSummaryLabel(scentingVal, isNatural, selectedScentCount);
      }
    }

    const strengthTexts = {};
    for (let i = 1; i <= maxScents; i++) {
      const el = strengthByIndex[i];
      if (!el) continue;
      strengthTexts[i] = displayStrength(el.value, { perScent: perScent5 });
    }

    for (let i = 1; i <= 5; i++) {
      const row = qs(`[data-summary-scent-${i}-row]`, root);
      const dd = qs(`[data-summary-scent-${i}]`, root);
      if (!row && !dd) continue;
      const sel = realScents[i - 1] || scentByIndex[i];
      let v = '';
      if (!isNatural) v = valOf(sel);
      /* Goat legacy: 3rd scent summary still mirrors add-third checkbox when present. */
      if (!perScent5 && i === 3 && addThird && !addThird.checked) v = '';
      const st = v ? (strengthTexts[i] || '') : '';
      const display = v ? (st ? `${v} · ${st}` : v) : '';
      if (i === 1) {
        if (row) row.hidden = !!(perScent5 && isNatural);
        if (dd) dd.textContent = (perScent5 && isNatural) ? '' : (display || 'Select a scent');
      } else {
        if (row) row.hidden = !v;
        if (dd && v) dd.textContent = display;
      }
    }

    const surRow = qs('[data-summary-surcharge-row]', root);
    const sur = qs('[data-summary-surcharge]', root);
    const stEl = qs('[data-summary-strength]', root);
    const stRow = qs('[data-summary-strength-row]', root);
    if (perScent5) {
      if (surRow) surRow.hidden = true;
      if (stRow) stRow.hidden = true;
    } else {
      const s3v = valOf(realScents[2] || scentByIndex[3]);
      const thirdOn = !!(addThird && addThird.checked && s3v);
      if (surRow) surRow.hidden = !thirdOn;
      if (sur && thirdOn) sur.textContent = surchargeText || 'Additional charge';
      const stv = strength ? displayStrength(strength.value, { perScent: false }) : '';
      if (stEl) stEl.textContent = stv || 'Select strength';
      if (stRow) stRow.hidden = false;
    }

    const chipHost = qs('[data-scent-chips]', root);
    if (perScent5) {
      /* Duplicate of SC selects + Creation summary — hide on per-scent-5 only. */
      if (chipHost) chipHost.innerHTML = '';
    } else {
      const chipScents = isNatural
        ? []
        : realScents.filter((sel, idx) => {
            const v = valOf(sel);
            if (!v) return false;
            if (idx === 2 && addThird && !addThird.checked) return false;
            return true;
          });
      renderChips(root, chipScents);
    }

    const selectedVariant = getSelectedShopifyVariant(root);
    if (selectedVariant) applyShopifyVariantDisplays(root, selectedVariant);
    const priceEl = qs('[data-summary-price]', root);

    const payload = {
      size: qs('[data-summary-size]', root)?.textContent || null,
      scenting: scentingVal || null,
      natural: isNatural,
      price: selectedVariant && selectedVariant.price != null ? selectedVariant.price : (priceEl ? priceEl.textContent : null),
    };
    for (let i = 1; i <= maxScents; i++) {
      const sel = realScents[i - 1] || scentByIndex[i];
      let v = isNatural ? null : (valOf(sel) || null);
      if (!perScent5 && i === 3 && addThird && !addThird.checked) v = null;
      payload['scent' + i] = v;
      payload['strength' + i] = v && strengthTexts[i] ? strengthTexts[i] : null;
    }
    if (!perScent5) {
      const s3v = payload.scent3;
      const thirdOn = !!(addThird && addThird.checked && s3v);
      payload.addThirdScent = thirdOn;
      payload.thirdScentSurcharge = thirdOn ? (surchargeText || null) : null;
      payload.strength = strength ? displayStrength(strength.value, { perScent: false }) : null;
    }
    writeState(root, payload);
  };

  document.addEventListener('input', (event) => {
    const filter = event.target.closest('[data-sc-scent-filter]');
    if (!filter) return;
    const root = qs('[data-customizable="true"]');
    const form = qs('#product-form', root);
    if (!form) return;
    const q = filter.value.trim().toLowerCase();
    qsa('select', form).forEach((sel) => {
      if (sel.closest('salus-variant-picker')) return;
      if (!/scent|fragrance|aroma/.test(labelOf(sel)) && sel.closest('[data-sc-scent-mount]') == null) return;
      Array.from(sel.options).forEach((opt) => {
        if (!opt.value) return;
        const match = !q || opt.text.toLowerCase().includes(q);
        opt.hidden = !match;
        opt.disabled = !match && opt !== sel.selectedOptions[0];
      });
    });
  });

  document.addEventListener('change', (event) => {
    if (!qs('[data-customizable="true"]')) return;
    if (event.target.closest('#product-form')) syncSalusCreationFromSc();
  });

  const observeScUnitTotal = (root) => {
    if (!root || root.dataset.scUnitObserved === '1') return;
    root.dataset.scUnitObserved = '1';
    let ticking = false;
    const kick = () => {
      if (ticking || root.dataset.salusApplying === '1') return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        refreshPdpPrices(root);
        syncSalusCreationFromSc();
      });
    };
    const form = root.querySelector('#product-form');
    if (!form) return;
    const mo = new MutationObserver((mutations) => {
      const relevant = mutations.some((m) => {
        const node = m.target && m.target.nodeType === 3 ? m.target.parentElement : m.target;
        if (node && node.closest && (node.closest('.bold_option_total') || node.closest('.bold_options'))) return true;
        return [...(m.addedNodes || [])].some(
          (n) =>
            n.querySelector &&
            (n.querySelector('.bold_option_total, .bold_options') ||
              (n.classList && (n.classList.contains('bold_options') || n.classList.contains('bold_option_total'))))
        );
      });
      if (relevant) kick();
    });
    mo.observe(form, { childList: true, subtree: true, characterData: true });
  };

  document.addEventListener('variant:change', (event) => {
    refreshPdpPrices(event.target);
  });

  const applyKeystonePriceDetail = (detail) => {
    if (!detail) return;
    const add = Number(detail.additionalPriceCents);
    if (!Number.isFinite(add) || add < 0) return;
    keystoneAddonUnitCents = add;
    const root = qs('.pdp');
    if (root) refreshPdpPrices(root);
    syncSalusCreationFromSc();
  };

  /* Keystone public storefront events (document CustomEvent + KeyOptions.on). */
  document.addEventListener('key:options:price-updated', (event) => {
    applyKeystonePriceDetail(event && event.detail);
  });
  document.addEventListener('key:options:ready', () => {
    relabelMakeItYours();
    readKeystoneAddonUnitCents();
    refreshPdpPrices(qs('.pdp'));
    syncSalusCreationFromSc();
  });
  document.addEventListener('key:options:change', () => {
    relabelMakeItYours();
    /* Selections changed; price-updated usually follows — soft refresh from API. */
    const prev = keystoneAddonUnitCents;
    keystoneAddonUnitCents = null;
    const next = readKeystoneAddonUnitCents();
    if (next === 0 && prev != null) keystoneAddonUnitCents = prev; /* keep until price-updated */
    else refreshPdpPrices(qs('.pdp'));
    syncSalusCreationFromSc();
  });

  const bindKeyOptionsApi = () => {
    const KO = window.KeyOptions;
    if (!KO || typeof KO.on !== 'function' || KO.__salusPriceBound === 1) return !!KO;
    KO.__salusPriceBound = 1;
    try {
      KO.on('price-updated', (detail) => applyKeystonePriceDetail(detail));
      KO.on('ready', () => {
        readKeystoneAddonUnitCents();
        refreshPdpPrices(qs('.pdp'));
        syncSalusCreationFromSc();
      });
      KO.on('change', () => { syncSalusCreationFromSc(); });
      if (typeof KO.whenReady === 'function') {
        KO.whenReady().then(() => {
          readKeystoneAddonUnitCents();
          refreshPdpPrices(qs('.pdp'));
          syncSalusCreationFromSc();
        }).catch(() => {});
      }
    } catch (err) { /* ignore */ }
    return true;
  };

  const bootScMirror = () => {
    const root = qs('.pdp');
    bindKeyOptionsApi();
    readKeystoneAddonUnitCents();
    refreshPdpPrices(root);
    syncSalusCreationFromSc();
    observeScUnitTotal(root);
    setTimeout(() => { bindKeyOptionsApi(); refreshPdpPrices(root); }, 400);
    setTimeout(syncSalusCreationFromSc, 400);
    setTimeout(() => { bindKeyOptionsApi(); refreshPdpPrices(root); }, 1200);
    setTimeout(syncSalusCreationFromSc, 1200);
    setTimeout(() => { bindKeyOptionsApi(); refreshPdpPrices(root); }, 2500);
    setTimeout(syncSalusCreationFromSc, 2500);
  };
  /* SALUS free-shipping progress celebration (cart shipping-bar only) */
  const FS_LAST_KEY = 'salus_fs_last_subtotal_cents';
  const fsCelebratedKey = (thresholdCents) => `salus_fs_celebrated_${thresholdCents}`;

  const readFsLast = () => {
    const raw = sessionStorage.getItem(FS_LAST_KEY);
    if (raw == null || raw === '') return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  };

  const writeFsLast = (cents) => {
    sessionStorage.setItem(FS_LAST_KEY, String(Math.max(0, Number(cents) || 0)));
  };

  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const fireShippingConfetti = (host) => {
    if (!host || prefersReducedMotion()) return;
    const layer = host.querySelector('[data-shipping-confetti]');
    if (!layer) return;
    layer.hidden = false;
    layer.innerHTML = '';
    const count = 48;
    for (let i = 0; i < count; i += 1) {
      const piece = document.createElement('span');
      piece.className = 'salus-confetti-piece';
      piece.style.left = `${2 + Math.random() * 96}%`;
      piece.style.setProperty('--dx', `${(Math.random() * 120) - 60}px`);
      piece.style.setProperty('--dy', `${90 + Math.random() * 70}px`);
      piece.style.animationDelay = `${Math.random() * 180}ms`;
      piece.style.animationDuration = `${900 + Math.random() * 500}ms`;
      layer.appendChild(piece);
    }
    window.setTimeout(() => {
      layer.innerHTML = '';
      layer.hidden = true;
    }, 1600);
  };

  const pulseUnlockedLabel = (host) => {
    const label = host && host.querySelector('[data-shipping-label]');
    if (!label) return;
    label.classList.add('shipping-bar__label--celebrate');
    window.setTimeout(() => label.classList.remove('shipping-bar__label--celebrate'), 1600);
  };

  const maybeCelebrateFreeShipping = (prevCents, nextCents, thresholdCents, host) => {
    if (!Number.isFinite(thresholdCents) || thresholdCents <= 0) return;
    /* Reset celebrate flag whenever eligible subtotal drops below threshold */
    if (Number.isFinite(nextCents) && nextCents < thresholdCents) {
      sessionStorage.removeItem(fsCelebratedKey(thresholdCents));
      return;
    }
    if (sessionStorage.getItem(fsCelebratedKey(thresholdCents))) return;
    if (prevCents == null) return; /* no prior session subtotal: do not celebrate if already over */
    if (prevCents < thresholdCents && nextCents >= thresholdCents) {
      fireShippingConfetti(host);
      pulseUnlockedLabel(host);
      sessionStorage.setItem(fsCelebratedKey(thresholdCents), '1');
    }
  };

  const seedFsLastFromCart = async () => {
    if (readFsLast() != null) return;
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      if (cart && typeof cart.total_price === 'number') writeFsLast(cart.total_price);
    } catch (err) { /* ignore */ }
  };

  const bootFreeShippingBar = () => {
    const bar = qs('[data-shipping-bar]');
    if (!bar) {
      seedFsLastFromCart();
      return;
    }
    const threshold = Number(bar.dataset.thresholdCents);
    const current = Number(bar.dataset.subtotalCents);
    const prev = readFsLast();
    maybeCelebrateFreeShipping(prev, current, threshold, bar);
    if (Number.isFinite(current)) writeFsLast(current);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootFreeShippingBar);
  } else {
    bootFreeShippingBar();
  }

  /* Keep last subtotal as pre-change value across cart/change reload transitions */
  document.addEventListener('change', (event) => {
    const input = event.target.closest('.qty__input[data-line-key]');
    if (!input) return;
    const bar = qs('[data-shipping-bar]');
    if (bar && bar.dataset.subtotalCents != null) writeFsLast(Number(bar.dataset.subtotalCents));
  }, true);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-remove-line]');
    if (!link) return;
    const bar = qs('[data-shipping-bar]');
    if (bar && bar.dataset.subtotalCents != null) writeFsLast(Number(bar.dataset.subtotalCents));
  }, true);

  /* Seed / preserve last subtotal around ATC so cart landing can detect under→over */
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[action*="/cart/add"], [data-quick-add], #product-form');
    if (!form) return;
    seedFsLastFromCart();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootScMirror);
  } else {
    bootScMirror();
  }



  /* Instagram feed: open profile in new tab (replace Instafeed modal) */
  (function /* salus-ig-newtab-v2 2026-09-07 */
  salusInstagramNewTab() {
    const PROFILE = 'https://www.instagram.com/salus/';
    const getUrl = () => {
      const host = document.querySelector('[data-instagram-follow]');
      const fromHost = host && host.getAttribute('data-instagram-url');
      return (fromHost && fromHost.trim()) || PROFILE;
    };
    const openProfile = (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      }
      const url = getUrl();
      window.open(url, '_blank', 'noopener,noreferrer');
      return false;
    };
    const bindFeed = (root) => {
      if (!root || root.dataset.salusIgBound === '1') return;
      root.dataset.salusIgBound = '1';
      root.addEventListener('click', (event) => {
        const hit = event.target.closest('a, button, [role="button"], .instafeed-item, [class*="instafeed"]');
        if (!hit) return;
        // Only intercept inside the feed grid
        if (!root.contains(hit)) return;
        openProfile(event);
      }, true);
    };
    const boot = () => {
      const section = document.getElementById('shopify-section-17888377685edfce52');
      const feed = document.getElementById('insta-feed') || (section && section.querySelector('#insta-feed, [id*="insta"]'));
      if (feed) bindFeed(feed);
      if (section) bindFeed(section);
      // Instafeed may hydrate late
      const obs = new MutationObserver(() => {
        const f = document.getElementById('insta-feed');
        if (f) bindFeed(f);
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(() => obs.disconnect(), 15000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();

})();
